import { SliderResponseRangeFragment, SurveyQuestionResponseStatistics } from '@occc/graphql';
import { BarPieceItem } from '../../../../design-system';

export const convertSliderResponseRangesToBarChartData = (
  sliderResponseRanges: SliderResponseRangeFragment[] = [],
): BarPieceItem<SurveyQuestionResponseStatistics['sliderResponseRanges'][0]>[] =>
  sliderResponseRanges.map<
    BarPieceItem<SurveyQuestionResponseStatistics['sliderResponseRanges'][0]>
  >((item) => ({
    name: item.rangeEnd.toString(),
    value: item.count,
    rawItem: item,
  }));
